<!-- <div class="w-full max-w-md pt-10 mx-auto">
    <a
      routerLink="/"
      class="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" class="size-5"><path d="M12.7083 5L7.5 10.2083L12.7083 15.4167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      Back to dashboard
    </a>
  </div> -->

<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
  <div>
    <div class="mb-5 sm:mb-8">
      <h1
        class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md"
      >
        Sign In
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Please sign in with your Microsoft account.
      </p>
    </div>

    <!-- OAuth Buttons -->
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-1 sm:gap-5">
      <!-- <button class="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-7 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.7511 10.1944C18.7511 9.47495 18.6915 8.94995 18.5626 8.40552H10.1797V11.6527H15.1003C15.0011 12.4597 14.4654 13.675 13.2749 14.4916L13.2582 14.6003L15.9087 16.6126L16.0924 16.6305C17.7788 15.1041 18.7511 12.8583 18.7511 10.1944Z"
              fill="#4285F4"
            />
            <path
              d="M10.1788 18.75C12.5895 18.75 14.6133 17.9722 16.0915 16.6305L13.274 14.4916C12.5201 15.0068 11.5081 15.3666 10.1788 15.3666C7.81773 15.3666 5.81379 13.8402 5.09944 11.7305L4.99473 11.7392L2.23868 13.8295L2.20264 13.9277C3.67087 16.786 6.68674 18.75 10.1788 18.75Z"
              fill="#34A853"
            />
            <path
              d="M5.10014 11.7305C4.91165 11.186 4.80257 10.6027 4.80257 9.99992C4.80257 9.3971 4.91165 8.81379 5.09022 8.26935L5.08523 8.1534L2.29464 6.02954L2.20333 6.0721C1.5982 7.25823 1.25098 8.5902 1.25098 9.99992C1.25098 11.4096 1.5982 12.7415 2.20333 13.9277L5.10014 11.7305Z"
              fill="#FBBC05"
            />
            <path
              d="M10.1789 4.63331C11.8554 4.63331 12.9864 5.34303 13.6312 5.93612L16.1511 3.525C14.6035 2.11528 12.5895 1.25 10.1789 1.25C6.68676 1.25 3.67088 3.21387 2.20264 6.07218L5.08953 8.26943C5.81381 6.15972 7.81776 4.63331 10.1789 4.63331Z"
              fill="#EB4335"
            />
          </svg>
          Sign in with Google
        </button> -->
      <button
        class="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-7 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-60"
        (click)="onMicrosoftSignIn()"
        [disabled]="signingIn"
      >
        <span class="grid place-items-center">
          @if (signingIn) {
            <i class="pi pi-spin pi-spinner"></i>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="16"
              height="16"
              viewBox="0 0 48 48"
            >
              <path
                fill="#ff5722"
                d="M6 6H22V22H6z"
                transform="rotate(-180 14 14)"
              ></path>
              <path
                fill="#4caf50"
                d="M26 6H42V22H26z"
                transform="rotate(-180 34 14)"
              ></path>
              <path
                fill="#ffc107"
                d="M26 26H42V42H26z"
                transform="rotate(-180 34 34)"
              ></path>
              <path
                fill="#03a9f4"
                d="M6 26H22V42H6z"
                transform="rotate(-180 14 34)"
              ></path>
            </svg>
          }
        </span>
        {{ signingIn ? 'Redirecting...' : 'Sign in with Microsoft' }}
      </button>
    </div>

    <!-- Divider -->
    <div class="relative py-3 sm:py-5">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-200 dark:border-gray-800"></div>
      </div>
      <div class="relative flex justify-center text-sm">
        <span
          class="p-2 text-gray-400 bg-white dark:bg-gray-900 sm:px-5 sm:py-2"
        >
          Or
        </span>
      </div>
    </div>

    <!-- Form -->
    <!-- Sign In Form -->
    <!-- <form [formGroup]="loginForm" (ngSubmit)="onSignIn()" class="space-y-6"> -->
    <!-- Email -->
    <!-- <div>
        <label
          class="block mb-2 font-medium text-sm text-[#0f172a] dark:text-white"
        >
          Email <span class="text-red-500">*</span>
        </label>

        <input
          type="email"
          pInputText
          class="w-full"
          placeholder="info@gmail.com"
          formControlName="email"
        />

        <small
          *ngIf="
            loginForm.get('email')?.touched && loginForm.get('email')?.invalid
          "
          class="text-red-500"
        >
          Enter a valid email
        </small>
      </div> -->

    <!-- Password -->
    <!-- <div>
        <label
          class="block mb-2 font-medium text-sm text-[#0f172a] dark:text-white"
        >
          Password <span class="text-red-500">*</span>
        </label>

        <div class="relative">
          <input
            [type]="showPassword ? 'text' : 'password'"
            pInputText
            class="w-full pr-10"
            placeholder="Enter your password"
            formControlName="password"
          /> -->

    <!-- Eye Icon -->
    <!-- <span
            (click)="togglePasswordVisibility()"
            class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
          >
            <i
              class="pi"
              [ngClass]="showPassword ? 'pi-eye' : 'pi-eye-slash'"
            ></i>
          </span>
        </div>

        <small
          *ngIf="
            loginForm.get('password')?.touched &&
            loginForm.get('password')?.invalid
          "
          class="text-red-500"
        >
          Password is required
        </small>
      </div> -->

    <!-- Remember + Forgot -->
    <!-- <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <p-checkbox
            binary="true"
            [(ngModel)]="isChecked"
            [ngModelOptions]="{ standalone: true }"
          ></p-checkbox>

          <span class="text-sm text-gray-600 dark:text-gray-400">
            Keep me logged in
          </span>
        </div>

        <a
          routerLink="/reset-password"
          class="text-sm text-indigo-500 hover:text-indigo-600"
        >
          Forgot password?
        </a>
      </div> -->

    <!-- Button -->
    <!-- <button
        type="submit"
        class="w-full h-12 rounded-xl bg-indigo-500 hover:bg-indigo-600 text-white font-semibold transition"
      >
        Sign In
      </button>
    </form> -->

    <!-- <div class="mt-5">
      <p
        class="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start"
      >
        Don't have an account?
        <a
          routerLink="/signup"
          class="text-brand-500 hover:text-brand-600 dark:text-brand-400"
        >
          Sign Up
        </a>
      </p>
    </div> -->
    <!-- Bottom Register Card -->
    <!-- Bottom Register Card -->
    <div
      class="mt-1 relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-700 via-indigo-600 to-blue-500 dark:from-slate-950 dark:via-blue-950 dark:to-indigo-950 p-7 text-center shadow-xl shadow-[#161950]/30"
    >
      <!-- Glow Effect -->
      <div
        class="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-[#4f66ff]/20 blur-3xl"
      ></div>

      <div
        class="absolute -bottom-10 -left-10 h-32 w-32 rounded-full bg-[#2d3ecf]/20 blur-3xl"
      ></div>

      <!-- Content -->
      <div class="relative z-10">
        <h3 class="text-lg font-semibold text-white">Don’t have an account?</h3>

        <p class="mt-2 text-sm leading-6 text-blue-100/80">
          Create your account to access the platform.
        </p>

        <a
          routerLink="/signup"
          class="group mt-6 inline-flex items-center justify-center gap-2 rounded-xl bg-white px-4 py-3 text-sm font-semibold text-[#161950]"
        >
          Create Account
        </a>
      </div>
    </div>
  </div>
</div>
